import api, { globalErrorHandler } from "../Api";

export const GET_GROWTH_OPPORTUNITIES = "GET_GROWTH_OPPORTUNITIES";
export const SET_GROWTH_OPPORTUNITY = "SET_GROWTH_OPPORTUNITY";
export const GET_JOBS_APPLIED = "GET_JOBS_APPLIED";
export const GET_GROWTH_OPPORTUNITY = "GET_GROWTH_OPPORTUNITY";
export const GET_GROWTH_OPPORTUNITY_METRICS = "GET_GROWTH_OPPORTUNITY_METRICS";

const url = "https://middleware.foundever.com/GOAPI";
export const getGrowthOpportunities = () => (dispatch) => {
  api
    .get(`${url}/api/Opening/GetActiveOpenings`)
    .then((res) => {
      dispatch({
        type: GET_GROWTH_OPPORTUNITIES,
        payload: res.data,
      });
      //console.log("action job opening", res.data)
    })
    .catch((error) => {
      globalErrorHandler(error);
    });
};

export const getJobsApplied = (badge) => (dispatch) => {
  api
    .get(`${url}/api/Application/GetMyApplications?employeeID=${badge}`)
    .then((res) => {
      dispatch({
        type: GET_JOBS_APPLIED,
        payload: res.data,
      });
    })
    .catch((error) => {
      globalErrorHandler(error);
    });
};

export const setGrowthOpportunity = (payload) => (dispatch) => {
  dispatch({
    type: SET_GROWTH_OPPORTUNITY,
    payload: payload,
  });
};

export const getGrowthOpportunity = (id) => (dispatch) => {
  dispatch({
    type: GET_GROWTH_OPPORTUNITY,
    payload: null,
  });

  api
    .get(`${url}/api/Opening/GetByID?id=${id}`)
    .then((res) =>
      dispatch({
        type: GET_GROWTH_OPPORTUNITY,
        payload: res.data,
      })
    )
    .catch(globalErrorHandler);
};

export const getGrowthOpportunityMetrics = (badge) => (dispatch) => {
  api.defaults.headers.common["Authorization"] =
    "Bearer " + localStorage.getItem("jwt_token");
  api
    .get(`${url}/api/Employee/GetMetrics?employeeID=${badge}`)
    .then((res) => {
      dispatch({
        type: GET_GROWTH_OPPORTUNITY_METRICS,
        payload: res.data,
      });
      //console.log(res.data)
    })
    .catch((error) => {
      globalErrorHandler(error);
    });
};
